export const getNextSectionCode = (survey) => {
  const usedCodes = new Set(survey.sections.map((section) => section.code));
  let sectionNumber = survey.sections.length + 1;
  while (usedCodes.has(`${survey.code}_SEC${sectionNumber}`)) sectionNumber++;
  return `${survey.code}_SEC${sectionNumber}`;
};

export const removeSurveySection = (survey, deletedSection) => {
  const deletedQuestions = deletedSection.questions || [];
  const deletedQuestionCodes = new Set(
    deletedQuestions.filter((question) => question.code != null).map((question) => question.code)
  );
  const deletedQuestionIds = new Set(
    deletedQuestions.filter((question) => question.id != null).map((question) => String(question.id))
  );
  const reportConfiguration = survey.reportConfiguration;

  return {
    ...survey,
    sections: survey.sections
      .filter((section) => section.code !== deletedSection.code)
      .map((section) => ({
        ...section,
        showOrder: section.showOrder > deletedSection.showOrder ? section.showOrder - 1 : section.showOrder,
      })),
    ...(reportConfiguration ? {
      reportConfiguration: {
        ...reportConfiguration,
        sectionsToInclude: (reportConfiguration.sectionsToInclude || []).filter((section) =>
          section.code !== deletedSection.code
          && !(deletedSection.id != null && section.sectionId != null && String(section.sectionId) === String(deletedSection.id))
        ),
        questionFilters: (reportConfiguration.questionFilters || []).filter((filter) =>
          filter.sectionCode !== deletedSection.code
          && !deletedQuestionCodes.has(filter.questionCode)
          && !deletedQuestionCodes.has(filter.key)
          && !(filter.questionId != null && deletedQuestionIds.has(String(filter.questionId)))
        ),
      },
    } : {}),
  };
};
